import { Injectable } from '@angular/core';
import { AutoSaveOwnersDetailsStatus, OwnerInformationFormData } from '../../form-details.model';

@Injectable({
  providedIn: 'root'
})
export class AutosavePostFunctionsService {
  hasAnyOwnersChangesToUpdate(ownersStatus: AutoSaveOwnersDetailsStatus): boolean {
    return ownersStatus?.addedOrUpdated?.length > 0 || ownersStatus?.removed?.length > 0
  }

  updateOwnersIdsWithResponse(
    currentOwners: OwnerInformationFormData[],
    ownersStatus: AutoSaveOwnersDetailsStatus
  ): OwnerInformationFormData[] {
    if (!currentOwners?.length) {
      return [];
    }

    const addedOrUpdatedOwners: OwnerInformationFormData[] = ownersStatus?.addedOrUpdated || [];
    const removedOwners: OwnerInformationFormData[] = ownersStatus?.removed || [];

    return currentOwners.map(owner => {
      if (owner.tempUuid) {
        const matching = addedOrUpdatedOwners.find(u => u.tempUuid === owner.tempUuid);
        if (matching) {
          return { ...owner, id: matching.id, tempUuid: undefined };
        }
      }
      return owner;
    })
      .filter(owner => {
        if (owner.id) {
          return !removedOwners.some(r => r.id === owner.id);
        }
        if (owner.tempUuid) {
          return !removedOwners.some(r => r.tempUuid === owner.tempUuid);
        }
        return true;
      });
  }
}
